import CalendarSurfaceStore from '../store/schema/CalendarSurfaceStore';
import convertLayoutPositionToStyles from '../utils/convertLayoutPositionToStyles';
import { CalendarSurfaceTransformProps } from '../interfaces/CalendarSurfaceTransformProps';
import { SurfaceItem } from '../interfaces/SurfaceItem';
import { wrapToGridItem } from '../surfaceItems/GridItem';

/**
 * Generates a layout of surface items with conflicting items showing side-by-side ensuring they never visually overlap
 * @param items The collection of items
 * @param store The surface store
 * @param config The surface transform configuration
 * @param itemsConfig The items configuration
 * @param groupIndex The group index
 */
export function createItemsLayer(
    columnItems: SurfaceItem[],
    store: CalendarSurfaceStore,
    config: CalendarSurfaceTransformProps,
    groupIndex: number
): JSX.Element[] {
    return columnItems.map(item => {
        let layout = { ...{ left: 0, right: 0 }, ...config.itemsLayout.getVerticalLayout(item) };

        let itemConfig = config.getItemConfig(item.model);

        return wrapToGridItem(
            convertLayoutPositionToStyles(layout),
            item.key,
            itemConfig,
            item.model,
            itemConfig && itemConfig.template && itemConfig.template(store, item.model),
            groupIndex,
            item.key,
            false /*doesItemHaveConflicts*/
        );
    });
}
